import React from 'react';
import { getBackgroundColors } from '../utils/gradientBackgrounds';

interface GradientBackgroundProps {
  children?: React.ReactNode;
  backgroundIndex?: number;
  customColors?: string[];
  className?: string;
}

const GradientBackground: React.FC<GradientBackgroundProps> = ({
  children,
  backgroundIndex = 0,
  customColors,
  className = '',
}) => {
  const colors = customColors || getBackgroundColors(backgroundIndex);
  
  const gradientStyle: React.CSSProperties = {
    background: `linear-gradient(135deg, ${colors.join(', ')})`,
    minHeight: '100vh',
    width: '100vw',
    margin: 0,
    padding: 0,
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: -1,
  };

  return (
    <div style={gradientStyle} className={className}>
      {children}
    </div>
  );
};

export default GradientBackground;
